















import Vue from 'vue'
import { downloadFile } from '@/utils/index'

export default Vue.extend({
  props: ['data', 'filename', 'fn', 'simple', 'disabled'],
  methods: {
    async handleExport({ key }) {
      if (key === 'filter') {
        this.excute()
      }
    },
    async excute() {
      const res = await this.fn()
      downloadFile(res, this.filename)
    },
  },
})
